export class ApiError extends Error {
  constructor(
    public status: number,
    public body: unknown,
    public headers: Headers
  ) {
    super(`Request failed with status ${status}`);
    this.name = 'ApiError';
  }
}
